module.exports = __webpack_public_path__ + "files/ea23c8b5922efc15ddc6940ddcda2dd7.png";